export default {
  name: 'CartComponents',

  computed: {
    canShowOrderType() {
      return !this.AppType.isQRScanApp && this.AppConfig.Marketplace.ShowOrderTypes && (this.AppConfig.Marketplace.SupportsCollection || this.AppConfig.Marketplace.SupportsDelivery)
    },
    canShowQrData() {
      return this.AppType.isQRScanApp && (this.AppQrData || (!this.AppQrData && this.AppConfig.Marketplace.SelectQrDataRequired))
    },
    canShowScheduled() {
      return this.AppConfig.Marketplace.ScheduledOrder.Active
    },
    canShowCoupons() {
      return this.AppConfig.Cart.CouponsEnabled
    }
  }
}
